export const EvaluationRecruitmentGravity = {
    path: '/evaluation_recruitment_gravities',
    name: 'evaluation_recruitment_gravities',
    component: () => import('@/views/Evaluation/Gravity/EvaluationRecruitmentGravityPage.vue'),
    props: {
        type: 'EVALUATION_RECRUITMENT',
    },
    children: [
        {
            path: '/evaluation_recruitment_gravities/add',
            name: 'evaluation_recruitment_gravities.add',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                addAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_gravities/edit/:id',
            name: 'evaluation_recruitment_gravities.edit',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                updateAction: true, 
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_gravities/delete/:id',
            name: 'evaluation_recruitment_gravities.delete',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                deleteAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
        {
            path: '/evaluation_recruitment_gravities/view/:id',
            name: 'evaluation_recruitment_gravities.view',
            component: () => import('@/views/Evaluation/Gravity/Form/EvaluationGravityForm.vue'),
            props: {
                viewAction: true,
                type: 'EVALUATION_RECRUITMENT',
            }
        },
    ]
}